import React from "react";
import { BrButton } from "@govbr-ds/webcomponents-react";
import "./PopupHistoricoTransferencia.css";

const Campo = ({ label, valor }) => (
	<tr>
		<td style={{ fontWeight: 'bold', paddingRight: '24px', paddingLeft: '8px', whiteSpace: 'nowrap', verticalAlign: 'top', paddingBottom: '10px' }}>
			{label}
		</td>
		<td style={{ paddingBottom: '10px', paddingRight: '8px' }}>{valor || '-'}</td>
	</tr>
);

export const PopupDetalheErroGV = ({ item, onClose }) => {
	if (!item) return null;

	return (
		<div className="popup-overlay" onClick={onClose}>
			<div className="popup-modal" onClick={(e) => e.stopPropagation()}>
				<div className="popup-header">
					<h2>Detalhe do Erro #{item.idLog}</h2>
					<button
						type="button"
						className="popup-close-btn"
						onClick={onClose}
						aria-label="Fechar"
					>
						✕
					</button>
				</div>

				<div className="popup-content">
					<table style={{ width: '100%', borderCollapse: 'collapse', padding: '8px' }}>
						<tbody>
							<Campo label="ID"        valor={item.idLog} />
							<Campo label="Código"    valor={item.codigo} />
							<Campo label="Descrição" valor={item.descricao} />
							<Campo label="Nome do Arquivo" valor={item.nomeArquivo} />
							{(item.nomeOrgaoOrigem || item.pastaSeguraOrigem) && (
								<>
									<Campo label="Órgão Origem"        valor={item.nomeOrgaoOrigem} />
									<Campo label="Pasta Segura Origem" valor={item.pastaSeguraOrigem} />
								</>
							)}
							{(item.nomeOrgaoDestino || item.pastaSeguraDestino) && (
								<>
									<Campo label="Órgão Destino"        valor={item.nomeOrgaoDestino} />
									<Campo label="Pasta Segura Destino" valor={item.pastaSeguraDestino} />
								</>
							)}
							<Campo label="Data/Hora" valor={item.dataHoraFormatada} />
						</tbody>
					</table>
				</div>

				<div className="popup-footer">
					<div className=".buttons-footer">
						<BrButton emphasis="secondary" onClick={onClose}>
							Fechar
						</BrButton>
					</div>
				</div>
			</div>
		</div>
	);
};
